import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../auth/auth.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { Router} from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as urls from './../../../utilities/urls';

@Component({
    templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {
    changePasswordForm: UntypedFormGroup;
    userId: number;
    passwordChangeButtonLoading = false;

    constructor(private authService: AuthService, private drawerRef: NzDrawerRef, private notification: NzNotificationService,
                private router: Router, private modalService: NzModalService, private fb: UntypedFormBuilder,  private httpClient: HttpClient) {
                    this.changePasswordForm = this.fb.group({
                        oldPassword: ['', [Validators.required]],
                        password: ['', [Validators.required]],
                        passwordConfirm: ['', [Validators.required]]
                      });
                }

ngOnInit() {
    this.userId = this.authService.getUserId();
}
changePassword() {
    this.passwordChangeButtonLoading = true;
    this.notification.info('Please Wait', 'Loading', {nzKey: 'key'});
    if (this.changePasswordForm.valid) {
      const value = {
        email: this.authService.getEmail(),
        oldPassword: this.changePasswordForm.value.oldPassword,
        newPassword: this.changePasswordForm.value.password,
        type:  this.authService.getRole()
      };
      if (this.changePasswordForm.value.password === this.changePasswordForm.value.passwordConfirm) {
        return this.httpClient.post(urls.AuthUrls.changePassword , value).subscribe((response : any) => {
          this.notification.success(response.message, '', {
            nzKey : 'key'
          });
          this.passwordChangeButtonLoading = false;
          this.close();
          this.authService.logout().subscribe((response: any) => {
            this.showActionConfirmForChangePassword();
          });
        }, err => {
          this.passwordChangeButtonLoading = false;
        });
      } else {
        this.notification.error(
          'New Password and Confirm password should be same', '', {
          nzKey: 'key'
        }
        );
        this.passwordChangeButtonLoading = false;
      }
    } else {
      this.passwordChangeButtonLoading = false;
      // tslint:disable-next-line: forin
      for (const i in this.changePasswordForm.controls) {
        this.changePasswordForm.controls[i].markAsDirty();
        this.changePasswordForm.controls[i].updateValueAndValidity();
      }
    }

  }
  showActionConfirmForChangePassword() {
    this.modalService.success({
      nzTitle: 'you changed your password you need to login again',
      nzOkText: 'OK',
      nzOkType: 'danger',
    });

  }
close() {
    this.drawerRef.close();
  }
}
